// extracted by mini-css-extract-plugin
export default {"infoModal":"OrganizerInfoModal-module__infoModal___3nR9D"};